import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useDashboardDna } from './dna/useDashboardDna';
import { DashHeader } from './dna/DashHeader';
import { KpiGrid } from './dna/KpiGrid';
import { YearBlock } from './dna/YearBlock';
import { AcademicBlock } from './dna/AcademicBlock';
import { FinanceBlock } from './dna/FinanceBlock';
import { InsightsBlock, OperationsBlock } from './dna/OperationsBlock';
import { C } from './dna/theme';

const Skeleton = () => (
  <div className="space-y-4 animate-pulse" data-testid="dashboard-loading">
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-8">{[...Array(8)].map((_, i) => <div key={i} className="h-36 rounded-[22px] bg-[#F3EEF8]" />)}</div>
    <div className="h-72 rounded-[24px] bg-[#F3EEF8]" />
  </div>
);

export default function Dashboard2() {
  const { opts, filters, setFilters, data, loading, error, refresh } = useDashboardDna();
  return (
    <div className="flex flex-col gap-5 pb-10" style={{ color: C.ink }} data-testid="dashboard-dna">
      <style>{'@keyframes dashRise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}.dash-rise{animation:dashRise .45s cubic-bezier(.2,.7,.2,1) both}'}</style>
      <DashHeader opts={opts} filters={filters} setFilters={setFilters} onRefresh={refresh} loading={loading} generatedAt={data?.generated_at} />
      {error && <p className="flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm" style={{ borderColor: `${C.orange}55`, color: C.orange }} data-testid="dashboard-error"><AlertCircle className="h-4 w-4" />{error}</p>}
      {!data ? (loading && <Skeleton />) : (
        <div className={`flex flex-col gap-5 transition-opacity duration-200 ${loading ? 'opacity-60' : ''}`}>
          <KpiGrid k={data.kpis} fin={data.finance} acad={data.academic} year={data.year} />
          <div className="grid gap-5 xl:grid-cols-[1.6fr_1fr]">
            <YearBlock rows={data.students_by_year} year={data.year} />
            <InsightsBlock items={data.insights} />
          </div>
          <AcademicBlock block={data.academic_block} acad={data.academic} />
          <div className="grid gap-5 xl:grid-cols-[1.6fr_1fr]">
            <FinanceBlock fin={data.finance} year={data.year} />
            <OperationsBlock ops={data.operations} />
          </div>
        </div>
      )}
    </div>
  );
}
